module.exports = __webpack_public_path__ + "static/media/bank.7cdb0bb1.png";